import { ADD_CART_REQUEST, ADD_CART_SUCCESS, ADD_CART_FAILURE, FETCH_CART_REQUEST, FETCH_CART_SUCCESS, FETCH_CART_FAILURE } from "../actions/cartActions";

const initialState = {
    cartData: null,
    isLoading: false,
    error: null,
};


const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CART_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };

        case ADD_CART_SUCCESS:
            return {
                ...state,
                // cartData: action.payload,
                isLoading: false,
            };

        case ADD_CART_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };

        case FETCH_CART_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case FETCH_CART_SUCCESS:
            return {
                ...state,
                cartData: action.payload,
                isLoading: false,
            };
            
        case FETCH_CART_FAILURE:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };

        default:
            return state;
    }
};

export default cartReducer;
